import { template as template_7c75875e74134763b9a611e8c5b16f20 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import type { Model } from '../../routes/render/icon';
export default RouteTemplate(template_7c75875e74134763b9a611e8c5b16f20(`
  <@model.Component />
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
